import { combineReducers } from 'redux';

import widget_reducer from './widget-reducer';

// import builder from './tableBuilderReducer';
// import nav from "./NavReducer"
// import gv from "./groupVariableReducer"
// import variable from "./varibalesReducer"

export default combineReducers({
    widget_reducer
    // builder,
    // nav,
    // gv,
    // variable
});